<script lang="ts">
    import type {LoginView} from 'shared/login/kp-login/types';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import {getSanitize} from 'core/svelte-context/context';
    import {exists} from 'shared/utils/custom-utils';
    import {LoginSystemIdToComponentMap} from 'shared/login/kp-login/login-systems/login-system-id-to-component.map';
    import LoginSystemContextProvider from 'shared/login/kp-login/LoginSystemContextProvider.svelte';
    import type {Auth} from 'typings/portaro.be.types';
    import {setLoginFormContext} from 'shared/login/kp-login/context';

    export let loginView: LoginView;
    export let onLoginSuccess: (auth: Auth) => void;
    export let onLoginCancel: () => void;

    $: visibleAuthSystems = loginView.authSystemViews.filter((authSystem) => authSystem.showingInMainLogin);

    const sanitize = getSanitize();
    const {state$} = setLoginFormContext();

    $: errorMessage = $state$?.errorMessage ?? null;
    $: showProcessing = $state$?.status === 'PROCESSING';
</script>


<div class="login-container">
    <div class="auth-systems">
        {#each visibleAuthSystems as authSystem(authSystem.id)}
            <div class="auth-system {authSystem.id}">
                <LoginSystemContextProvider {loginView} authSystemView="{authSystem}" {onLoginSuccess} {onLoginCancel}>
                    <svelte:component this="{LoginSystemIdToComponentMap[authSystem.id]}"/>
                </LoginSystemContextProvider>
            </div>
        {/each}

    </div>

    <KpLoadingBlock showWhen="{showProcessing}" size="xs"/>

    {#if (exists(errorMessage))}
        <div class="login-error" role="alert">
            {@html sanitize(errorMessage)}
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .login-container {
        .login-error {
            margin-top: 10px;
            background-color: #f2dede;
            color: #f00;
            padding: 3px;
            border: 1px solid #f00;
            border-radius: 3px;
        }

        .auth-systems {
            margin-inline: auto;
            display: flex;
            flex-direction: column;
            gap: 20px;
            align-items: stretch;


            @media (min-width: @screen-sm-min) {
                width: 80%;
            }

            @media (min-width: @screen-md-min) {
                width: 60%;
            }

            :global {
                .auth-system {
                    &:not(:first-child) .login-system-panel-top-border {
                        border-top: 1px solid lightgray;
                    }
                }
            }
        }
    }
</style>